module.exports = __webpack_public_path__ + "09_hair_gold.ab4b7f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/09_hair_gold.png
// module id = Ub4d
// module chunks = 0